import { render, staticRenderFns } from "./StoreManagement.vue?vue&type=template&id=89901cd0&scoped=true&"
import script from "./StoreManagement.vue?vue&type=script&lang=js&"
export * from "./StoreManagement.vue?vue&type=script&lang=js&"
import style0 from "./StoreManagement.vue?vue&type=style&index=0&id=89901cd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89901cd0",
  null
  
)

export default component.exports
import {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtn,QCard,QCardSection,QTabs,QTab,QSeparator,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtn,QCard,QCardSection,QTabs,QTab,QSeparator,QTabPanels,QTabPanel})
